<template>
  <section 
	v-show="isActive"
	:id="getId"
	:aria-hidden="!isActive"
	role="tabpanel"
	class="tabs-component-panel">
    	<slot></slot>
  </section>
</template>

<script>
export default {
  props: {
    id: { default: null },
    name: { required: true },
    prefix: { default: '' },
    suffix: { default: '' }
  },
  data() {
    return {
      isActive: false
    };
  },
  computed: {
    header() {
      return this.prefix + this.name + this.suffix;
    },
    getId() {
      return this.id ? this.id : this.name.toLowerCase().replace(/ /g, '-');
    },
    hash() {
      return '#' + this.getId;
    }
  }
};
</script>
